import React from 'react';

import PropTypes from 'prop-types';

import { Flex } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

const ReferencePickerTopBar = ({ children }) => (
  <Flex
    justifyContent="space-between"
    alignItems="center"
    padding="12px 16px"
    borderBottom={`1px solid ${theme.colors.charcoal200}`}
  >
    {children}
  </Flex>
);

ReferencePickerTopBar.propTypes = {
  /** Top bar content */
  children: PropTypes.node,
};

export default ReferencePickerTopBar;
